/* global hj */
/* @ngInject */
function initializerService ($location, $rootScope, $q, $http, $cookies, $state, $window, $translate, AdminService, BillingService, RollbarService, CONSTANTS, Utils, AuthService, CacheService, CustomerConfigurationsService, IntegrationRegisterService, UserService, EventListenerService, LanguageService, SegmentService, ToastService, ModalService, NotificationsCentralService, SocialMediaService, ConnectorWebService, PostsService, $timeout) {
  (() => {
    resetLandingPage()
    validateJwtInUrl()
  })()
  let postsShown = false

  function validateJwtInUrl () {
    const jwt = $location.$$search.jwt
    if (!jwt) return
    AuthService.setJwtToken(jwt)
  }

  // reseta o aparecimento da landing page para proxima vez que ele acessar a web pela primeira vez
  function resetLandingPage () {
    const landingPageFlowExecuted = localStorage.getItem('landingPageFlowExecuted')
    if (!landingPageFlowExecuted) {
      localStorage.removeItem('landingPageFlowExecuted')
    }
  }

  function showAppLandingPage () {
    $rootScope.getUser().then(user => {
      const isToShowAppMobileFlow = shouldShowLandingPageAppFlow(user)
      const landingPageFlowExecuted = $rootScope.landingPageFlowExecuted

      if (isToShowAppMobileFlow && !landingPageFlowExecuted) {
        localStorage.setItem('landingPageFlowExecuted', 'true')
        window.location.href = 'https://lp.deskfy.io/app/'
      } else {
        localStorage.removeItem('landingPageFlowExecuted')
      }
    })
  }

  function shouldShowLandingPageAppFlow (user) {
    const isInReactNativeWebView = Utils.isInReactNativeWebView()

    if (user?.customerCompanyId === 1891) return false // desabilita a landing page para a ambev
    if (location.hostname.startsWith('royalface.deskfy.io')) return false // temporary workaround for specific client request

    // caso for web view, não for mobile ou se a LP ja apareceu, não deve se mostra-la
    if (isInReactNativeWebView || $rootScope.isDesktop) { return false }
    const state = $state.current?.name
    const pagesNotShowLandingPageAppFlow = ['login', 'signup', 'userVerification', 'rememberPassword', 'inactive', 'recoverPassword', 'twoFactorVerification', 'updatePassword', 'signupWorkflowPlan', 'welcome', 'onboardingStepBranding', 'onboardingStepCompany', 'onboardingStepModules', 'onboardingStepWaitingEmailConfirmation', 'publicDownload', 'publicFolder', 'blockLogins', 'emailConfirmation']
    return !pagesNotShowLandingPageAppFlow.includes(state)
  }

  const getChangedCompanyDialogController = () => $q.when(import('../dialogs/changed-company/changed-company-dialog.controller'))

  var pageChanges = [segmentPageChange]
  var pendingEnvDialog = false
  if (!location.hostname.startsWith('qa.deskfy.io') && !window.devEnv && !location.hostname.startsWith('qa2.deskfy.io')) {
    pageChanges.push(intercomPageChange)
    pageChanges.push(thirdPartyPageChange)
  }

  function handlePostsAutoShowAfterLogin () {
    if (!$cookies.get('jwt') || !$rootScope.oUser || !$rootScope.isUser($rootScope.oUser) || Utils.isInReactNativeWebView() || postsShown) {
      return $q.when()
    }

    postsShown = true
    const url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_USERS_ME_POSTS_OPEN_UPON_ENTRY)
    return ConnectorWebService.get(url).then(posts => {
      if (!posts.rows.length) return

      const currentIndex = 0
      const totalPosts = posts.count
      const storedPosts = posts.rows

      return PostsService.showPostModal(storedPosts[currentIndex], currentIndex, totalPosts, storedPosts)
    })
  }

  const api = {
    getChangedCompanyDialogController,
    _checkUserRole,
    sucessCallbackGetUser,
    sucessCallbackGetUserCompany,
    successGetCompanies,
    successGetContexts,
    sucessCallbackGetUserCompanyConfigurations,
    sucessCallbackGetColor,
    successCallbackGetUserFeatures,
    initApplication
  }
  return api

  async function sucessCallbackGetUser (oUser) {
    // Compute user initials
    if (oUser.name) {
      const names = oUser.name.split(' ')
      oUser.initials = names[0][0] + (names.length > 1 ? names[1][0] : names[0][1])
    }

    if (oUser.locale && oUser.locale.toUpperCase() !== LanguageService.getLanguage().toUpperCase()) {
      LanguageService.setLocaleLanguage(oUser.locale.toUpperCase())
      $translate.use(LanguageService.getLanguage())
    }

    moment.locale(LanguageService.getLanguage())

    const companyFeaturesAndAddons = await $rootScope.getCompanyFeaturesAndAddons()
    const isWorkflowPlan = companyFeaturesAndAddons?.pricingPackageId === 4

    if (oUser.pendingEmailConfirmation) {
      $state.go('onboardingStepWaitingEmailConfirmation')
    } else if (oUser.onboarding_status === 'COMPANY') {
      $state.go('onboardingStepCompany')
    } else if (oUser.onboarding_status === 'MODULES') {
      $state.go('onboardingStepModules')
    } else if (oUser.onboarding_status === 'BRANDING') {
      $state.go(isWorkflowPlan ? 'onboardingStepBrandingWorkflow' : 'onboardingStepBranding')
    }

    $rootScope.oUser = oUser
    return $rootScope.oUser
  }

  function successCallbackGetUserFeatures (features) {
    $rootScope.oUserFeatures = features
  }

  function successGetDeskfyFeatures (features) {
    $rootScope.deskfyFeatures = features

    return $rootScope.deskfyFeatures
  }

  function successGetCompanyWithBillingPackage (companyWithBillingPackage) {
    $rootScope.companyWithBillingPackage = companyWithBillingPackage

    return $rootScope.companyWithBillingPackage
  }

  function successGetCompanyFeaturesAndAddons (companyFeaturesAndAddons) {
    $rootScope.companyFeaturesAndAddons = companyFeaturesAndAddons

    return $rootScope.companyFeaturesAndAddons
  }

  function updateUserDataInSession () {
    return UserService.getUser()
  }

  function successGetCompanies (res) {
    $rootScope.userCompanies = res.companies
  }

  function successGetContexts (contexts) {
    $rootScope.userContexts = contexts
  }

  function sucessCallbackGetUserCompany (oUserCompany) {
    $rootScope.oUserCompany = oUserCompany

    localStorage.setItem('company', oUserCompany.id)

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && !$state.current.public && !pendingEnvDialog && $rootScope.oUserCompany.id.toString() !== localStorage.getItem('company')) {
        openEnvironmentDialog()
      }
    })
  }

  function openEnvironmentDialog () {
    const oldModalReference = ModalService.getCurrentModal()
    pendingEnvDialog = true

    api.getChangedCompanyDialogController().then(({ ChangedCompanyDialogController }) => {
      ModalService.showModal({
        templateId: 'changedCompany.html',
        templateUrl: '/core/dialogs/changed-company/changed-company-dialog.html?$$REVISION$$',
        destroyable: true,
        allowMultiple: true,
        controller: ChangedCompanyDialogController
      }).then(reload => {
        if (reload) {
          $window.location.reload()
        } else {
          UserService
            .updateUserCompany($rootScope.oUserCompany.id)
            .catch(ToastService.defaultErrorToast)
            .then(() => {
              localStorage.setItem('company', $rootScope.oUserCompany.id)
              pendingEnvDialog = false
              ModalService.close()

              if (oldModalReference) {
                ModalService.setCurrentModal(oldModalReference)
                ModalService.showCurrentModal()
              }
            })
        }
      })
    })
  }

  function sucessCallbackGetUserCompanyConfigurations (oConfiguration) {
    var _oConfigurations = {}
    for (var key in oConfiguration) {
      for (var innerKey in oConfiguration[key]) {
        _oConfigurations[oConfiguration[key][innerKey].type] = oConfiguration[key][innerKey].value
      }
    }
    $rootScope.oUserCompanyConfigurations = _oConfigurations
  }

  function sucessCallbackGetFeatureConfigurations (features) {
    $rootScope.oUserCompanyFeatures = features
  }

  function sucessCallbackGetColor (oColor) {
    $rootScope.customerColor = oColor.value || $rootScope.customerColor || '#00abc8'
    document.documentElement.style.setProperty('--customer-color', $rootScope.customerColor)
    localStorage.setItem('customerColor', $rootScope.customerColor)
  }

  function successCallbackGetIsEnableSocialMedia (response) {
    $rootScope.isEnableSocialMedia = response.value
  }

  function successCallbackGetSocialMediaGateway (response) {
    $rootScope.socialMediaGateway = response
  }

  function checkBetaApp () {
    const companyFeatures = $rootScope.oUserCompanyFeatures
    const userFeatures = $rootScope.oUserFeatures

    const isUserBetaEnabled = userFeatures?.reduce((acc, feature) => {
      if (feature.type === 'APP_BETA') {
        acc = feature.value
      }

      return acc
    }, false)

    if (Utils.isInReactNativeWebView() && companyFeatures.length > 0) {
      companyFeatures.forEach(feature => {
        if (feature === 'APP_BETA' && isUserBetaEnabled) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'LOGOUT' }))
        }
      })
    }
  }

  function initApplication () {
    if ($cookies.get('jwt')) {
      $http.defaults.headers.common.Authorization = 'Bearer ' + $cookies.get('jwt', { domain: '.deskfy.io', path: '/' })
    }
    $rootScope.reloadCompanyConfigurations = () => CustomerConfigurationsService.getAllConfigurations().then(sucessCallbackGetUserCompanyConfigurations)
    $rootScope.landingPageFlowExecuted = localStorage.getItem('landingPageFlowExecuted')
    $rootScope.subdomain = localStorage.getItem('companySubdomain')
    $rootScope.uploadingFiles = []
    $rootScope.customerColor = localStorage.getItem('customerColor') || '#00abc8'
    $rootScope.isEnableSocialMedia = false
    $rootScope.socialMediaGateway = null
    $rootScope.fnLogOutUser = AuthService.logout.bind(this, { logoutByClick: true })
    $rootScope.isUserAdminDesigner = isUserAdminDesigner
    $rootScope.isUserSysAdminAdminDesigner = isUserSysAdminAdminDesigner
    $rootScope.isUserSysAdminAdmin = isUserSysAdminAdmin
    $rootScope.isUserSysAdmin = isUserSysAdmin
    $rootScope.isUserDesigner = isUserDesigner
    $rootScope.isUser = isUser
    $rootScope.isGuest = isGuest
    $rootScope.getCompanyConfigurations = getCompanyConfigurations
    $rootScope.getCompanyFeatures = getCompanyFeatures
    $rootScope.getUserCompany = getUserCompany
    $rootScope.getUser = getUser
    $rootScope.getUserFeatures = getUserFeatures
    $rootScope.getCustomerLogo = getCustomerLogo
    $rootScope.getCustomerLogoColor = getCustomerLogoColor
    $rootScope.getCustomerBackground = getCustomerBackground
    $rootScope.getCustomerLoginLogo = getCustomerLoginLogo
    $rootScope.getCustomerSymbolColor = getCustomerSymbolColor
    $rootScope.getPostNotificationsCount = getPostNotificationsCount
    $rootScope.getDeskfyFeatures = getDeskfyFeatures
    $rootScope.getCompanyWithBillingPackage = getCompanyWithBillingPackage
    $rootScope.getCompanyFeaturesAndAddons = getCompanyFeaturesAndAddons
    $rootScope.getEnableSocialMedia = getEnableSocialMedia
    $rootScope.getSocialMediaGateway = getSocialMediaGateway
    $rootScope.updateUserDataInSession = updateUserDataInSession
    $rootScope.abortUpload = abortUpload
    $rootScope.toggleUploadDialogVisibility = toggleUploadDialogVisibility
    $rootScope.showSidebar = showSidebar
    $rootScope.isMultilocalPlan = isMultilocalPlan
    $rootScope.isWorkflowPlan = isWorkflowPlan

    // Define responsive breakpoint and variables
    $rootScope.tabletBreakpoint = 768
    $rootScope.isDesktop = window.innerWidth > $rootScope.tabletBreakpoint
    $rootScope.URL_BACKEND = CONSTANTS.URL_BACKEND

    EventListenerService.registerEventListener('windowResizeRoot', window, 'resize', { substitute: false }, function () {
      $rootScope.isDesktop = window.innerWidth > $rootScope.tabletBreakpoint
    })

    $rootScope.isLandscape = window.orientation !== 0
    EventListenerService.registerEventListener('isLandscape', window, 'orientationchange', { substitute: false }, function () {
      $rootScope.isLandscape = window.orientation !== 0
      $rootScope.$digest()
    })

    $rootScope.$on('$stateChangeSuccess', stageChange)

    function dataPromise (reloadUser) {
      UserService.sendUserMetricsToExternalPlatforms().catch(() => {})
      UserService.sendUserCompanyMetricsToExternalPlatforms().catch(() => {})

      var aPromises = [
        getUser(),
        UserService.getUserCompanies(null, null, { active: true }).then(successGetCompanies),
        UserService.getUserContexts().then(successGetContexts),
        getUserCompany(),
        CustomerConfigurationsService.getAllConfigurations().then(sucessCallbackGetUserCompanyConfigurations),
        CustomerConfigurationsService.getFeatureConfigurations().then(sucessCallbackGetFeatureConfigurations),
        CustomerConfigurationsService.getOneConfigurationByType('COMPANY_PRIMARY_COLOR', 'STRING').then(sucessCallbackGetColor),
        CustomerConfigurationsService.getOneConfigurationByType('ENABLE_SOCIAL_MEDIA', 'BOOLEAN').then(successCallbackGetIsEnableSocialMedia),
        UserService.getFeatures().then(successCallbackGetUserFeatures),
        getDeskfyFeatures(),
        getCompanyFeaturesAndAddons()
      ]

      if ($rootScope.oUser?.role !== 'GUEST' && !isGuest) {
        aPromises.push(SocialMediaService.getGatewayUrl('instagram').then(successCallbackGetSocialMediaGateway))
      }

      if (reloadUser) {
        aPromises.push(UserService.getUser().then(sucessCallbackGetUser))
      }

      return $q.all(aPromises).then((oData) => {
        const [user] = oData
        var oParams = {
          user: reloadUser ? $rootScope.oUser : user,
          company: {
            ...$rootScope.oUserCompany,
            billingPackage: $rootScope.companyWithBillingPackage.billingPackage
          },
          oUserCompanyConfigurations: $rootScope.oUserCompanyConfigurations,
          iUnreadPostsCount: $rootScope.iUnreadPostsCount
        }

        checkBetaApp()
        RollbarService.init()
        IntegrationRegisterService.initialize(oParams)
        NotificationsCentralService.init()

        return oData
      })
    }

    return UserService.getUser().then((user) => {
      return sucessCallbackGetUser(user).then(() => {
        return new Promise((resolve, reject) => {
          var searchObject = $location.search()
          var customerCompanyId

          if (searchObject.company && searchObject.company > 0) {
            customerCompanyId = searchObject.company

            delete searchObject.company
          }

          if (searchObject.next) {
            var regExp = /company=([^&]*)/
            var params = regExp.exec(searchObject.next)
            if (params && params[1] > 0) {
              customerCompanyId = params[1]
              searchObject.next = searchObject.next.replace(regExp, '')
            }
          }

          if (customerCompanyId) {
            $location.search(searchObject)
            UserService
              .updateUserCompany(customerCompanyId)
              .then(dataPromise.bind(this, true))
              .then(() => {
                if ($rootScope.isUser($rootScope.oUser)) {
                  $timeout(() => {
                    return handlePostsAutoShowAfterLogin()
                  }, 1000)
                }
              })
              .then(resolve)
              .catch((e) => {
                reject(e)
                ToastService.showErrorToast($translate.instant('unauthorized'))
              })
          } else {
            dataPromise()
              .then(() => {
                if ($rootScope.isUser($rootScope.oUser)) {
                  $timeout(() => {
                    return handlePostsAutoShowAfterLogin()
                  }, 1000)
                }
              })
              .then(resolve)
              .catch(reject)
          }
        })
      })
    })
  }

  function toggleUploadDialogVisibility () {
    $rootScope.bMinimizeUploadDialog = !$rootScope.bMinimizeUploadDialog
    $rootScope.$broadcast('uploadtable.minimize', !$rootScope.bMinimizeUploadDialog)
  }

  function _checkUserRole (oUser, roles) {
    const user = oUser || $rootScope.oUser

    if (!user || !Array.isArray(roles)) {
      return false
    }

    return roles.includes(user.role)
  }

  /**
   * Checks if a User has role 'SYSTEM_ADMINISTRATOR' or 'ADMINISTRATOR' or 'DESIGNER'.
   * @param {object} [oUser]
   * @param {string} [oUser.role]
   * @returns {boolean}
   */
  function isUserSysAdminAdminDesigner (oUser) {
    return api._checkUserRole(oUser, ['SYSTEM_ADMINISTRATOR', 'ADMINISTRATOR', 'DESIGNER'])
  }

  function isUserDesigner (oUser) {
    return api._checkUserRole(oUser, ['DESIGNER'])
  }

  /**
   * Checks if a User has role 'ADMINISTRATOR' or 'DESIGNER'.
   * @param {object} [oUser]
   * @param {string} [oUser.role]
   * @returns {boolean}
   */
  function isUserAdminDesigner (oUser) {
    return api._checkUserRole(oUser, ['ADMINISTRATOR', 'DESIGNER'])
  }

  /**
   * Checks if a User has role 'SYSTEM_ADMINISTRATOR' or 'ADMINISTRATOR'.
   * @param {object} [oUser]
   * @param {string} [oUser.role]
   * @returns {boolean}
   */
  function isUserSysAdminAdmin (oUser) {
    return api._checkUserRole(oUser, ['SYSTEM_ADMINISTRATOR', 'ADMINISTRATOR'])
  }

  /**
   * Checks if a User has role 'SYSTEM_ADMINISTRATOR'.
   * @param {object} [oUser]
   * @param {string} [oUser.role]
   * @returns {boolean}
   */
  function isUserSysAdmin (oUser) {
    return api._checkUserRole(oUser, ['SYSTEM_ADMINISTRATOR'])
  }

  /**
   * Checks if a User has role 'USER'.
   * @param {object} [oUser]
   * @param {string} [oUser.role]
   * @returns {boolean}
   */
  function isUser (oUser) {
    return api._checkUserRole(oUser, ['USER'])
  }

  /**
   * Checks if a User has role 'GUEST'.
   * @param {object} [oUser]
   * @param {string} [oUser.role]
   * @returns {boolean}
   */
  function isGuest (oUser) {
    return api._checkUserRole(oUser, ['GUEST'])
  }

  /**
   * Fetches Customer Company Configurations.
   * @returns {Promise}
   */
  function getCompanyConfigurations () {
    if ($rootScope.oUserCompanyConfigurations) {
      return $q.resolve($rootScope.oUserCompanyConfigurations)
    } else {
      return UserService.getUserCompanyConfigurations()
    }
  }

  /**
   * Fetches Customer Company Features.
   * @returns {Promise}
   */
  function getCompanyFeatures () {
    if ($rootScope.oUserCompanyFeatures) {
      return $q.resolve($rootScope.oUserCompanyFeatures)
    } else {
      return CustomerConfigurationsService.getFeatureConfigurations()
    }
  }

  /**
   * Fetches Customer Company.
   * @returns {Promise}
   */
  function getUserCompany (forceReload = false) {
    if ($rootScope.oUserCompany && !forceReload) {
      return $q.resolve($rootScope.oUserCompany)
    } else {
      return UserService.getUserCompany(forceReload)
        .then((userCompany) => {
          sucessCallbackGetUserCompany(userCompany)

          return userCompany
        })
    }
  }

  function getDeskfyFeatures () {
    if ($rootScope.deskfyFeatures) {
      return $q.resolve($rootScope.deskfyFeatures)
    }

    return BillingService.getAllDeskfyFeatures().then(successGetDeskfyFeatures)
  }

  function getCompanyWithBillingPackage (forceReload = false) {
    if ($rootScope.companyWithBillingPackage && !forceReload) {
      return $q.resolve($rootScope.companyWithBillingPackage)
    }

    return $rootScope.getUserCompany().then((oUserCompany) => {
      return AdminService.getCompanyWithBillingPackage(oUserCompany.id).then(successGetCompanyWithBillingPackage)
    })
  }

  function getCompanyFeaturesAndAddons (forceReload = false) {
    if ($rootScope.companyFeaturesAndAddons && !forceReload) {
      return $q.resolve($rootScope.companyFeaturesAndAddons)
    }

    return $rootScope.getCompanyWithBillingPackage(true).then((companyWithBillingPackage) => {
      return BillingService.getCompanyFeaturesAndAddons(companyWithBillingPackage.billingPackage.planId, companyWithBillingPackage.billingPackage.id).then(successGetCompanyFeaturesAndAddons)
    })
  }

  function getEnableSocialMedia (forceReload = false) {
    if ($rootScope.isEnableSocialMedia && !forceReload) {
      return $q.resolve($rootScope.isEnableSocialMedia)
    }

    return CustomerConfigurationsService.getOneConfigurationByType('ENABLE_SOCIAL_MEDIA', 'BOOLEAN').then((response) => {
      return response.value
    })
  }

  function getSocialMediaGateway (socialType = 'instagram', forceReload = false) {
    if ($rootScope.socialMediaGateway && !forceReload) {
      return $q.resolve($rootScope.socialMediaGateway)
    }

    return SocialMediaService.getGatewayUrl(socialType).then((response) => {
      return response
    })
  }

  /**
   * Fetches User.
   * @returns {Promise}
   */
  function getUser (forceReload = false) {
    if ($rootScope.oUser && !forceReload) {
      return $q.resolve($rootScope.oUser)
    } else {
      return UserService.getUser(forceReload).then(sucessCallbackGetUser)
    }
  }

  /**
   * Fetches User features.
   * @returns {Promise}
   */
  function getUserFeatures () {
    if ($rootScope.oUserFeatures) {
      return $q.resolve($rootScope.oUserFeatures)
    } else {
      return UserService.getFeatures()
    }
  }

  /**
   * Returns customer logo path.
   * @returns {string}
   */
  function getCustomerLogo () {
    // Swap all big deskfy logos by mobile version and adds padding;
    if (!$rootScope.oUser) {
      return '/assets/img/logos/customer-logo-negative.webp'
    }
    return Utils.fnReplaceStringParams(
      CONSTANTS.URL_CUSTOMER_COMPANY_LOGO,
      [$rootScope.oUser.customerCompanyId]
    )
  }

  /**
   * Returns colored customer logo path.
   * @returns {string}
   */
  function getCustomerLogoColor () {
    // Swap all big deskfy logos by mobile version and adds padding;
    if (!$rootScope.oUser) {
      return '/assets/img/logos/customer-logo-negative.webp'
    }
    return Utils.fnReplaceStringParams(
      CONSTANTS.URL_CUSTOMER_COMPANY_LOGO_COLORED,
      [$rootScope.oUser.customerCompanyId]
    )
  }

  function getCustomerBackground (company) {
    if (!$rootScope.oUser || !company) {
      return ''
    }

    const url = Utils.fnReplaceStringParams(
      CONSTANTS.URL_EXTERNAL_COMPANY_SUBDOMAIN_BACKGROUND,
      [company.subdomain]
    )

    return Utils.fnAddQueryToUrl(url, { date: company.updatedAt })
  }

  function getCustomerSymbolColor () {
    if (!$rootScope.oUserCompany) {
      return ''
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_SYMBOL_COLORED, [$rootScope.oUserCompany.id])
    return Utils.fnAddQueryToUrl(url, { date: $rootScope.oUserCompany.updatedAt })
  }

  function getCustomerLoginLogo (company) {
    if (!$rootScope.oUser || !company) {
      return ''
    }

    const url = Utils.fnReplaceStringParams(
      CONSTANTS.URL_EXTERNAL_COMPANY_SUBDOMAIN_LOGO_LOGIN,
      [company.subdomain]
    )

    return Utils.fnAddQueryToUrl(url, { date: company.updatedAt })
  }

  /**
   * Fetches number of unread posts.
   * @returns {Promise}
   */
  function getPostNotificationsCount () {
    return UserService.getPostNotificationsCount().then(function (iUnreadPostsCount) {
      $rootScope.iUnreadPostsCount = iUnreadPostsCount
      return iUnreadPostsCount
    })
  }

  /**
   * Returns if sidebar should be shown
   * @returns {Promise}
   */
  function showSidebar () {
    const state = $state.current?.name
    const pagesNotShowSidebar = ['signup', 'login', 'loginSso', 'userVerification', 'rememberPassword', 'inactive', 'recoverPassword', 'twoFactorVerification', 'updatePassword', 'welcome', 'signupWorkflowPlan', 'onboardingStepBranding', 'onboardingStepBrandingWorkflow', 'onboardingStepCompany', 'onboardingStepModules', 'onboardingStepWaitingEmailConfirmation', 'publicDownload', 'publicFolder', 'customizeTemplate', 'customizeArt', 'startFromBlank', 'auditForm', 'blockLogins', 'guest.login', 'guest.resendPassword', 'guest.briefingSummary', 'guest.approvalSummary', 'assetPack.assetPackSummary', 'assetPack.assetPackFolder', 'assetPack.assetPackDownloadAll', 'emailConfirmation']
    return !pagesNotShowSidebar.includes(state)
  }

  function intercomPageChange (event, toState, toParams, fromState) {
    var pages = CacheService.getItem('pages') || []
    // Hide/show Intercom launcher on iframe-based pages (Mia/Editor)
    if (window.Intercom && $location && typeof $location.path === 'function') {
      var path = $location.path() || ''
      var shouldHideLauncher = path.indexOf('/ia') === 0 || path.indexOf('/documents/editor') === 0 || path.indexOf('/editor') === 0
      window.Intercom('update', { hide_default_launcher: shouldHideLauncher })
    }
    if (toState.name.indexOf('customize') !== -1 || fromState.name.indexOf('customize') !== -1) {
      window.Intercom('update', { update_time: Date.now(), previous_page: fromState.url })
    } else if (pages.indexOf(toState.name) === -1) {
      CacheService.setItem('pages', pages.concat([toState.name]), { hours: 8 })
      window.Intercom('update', { update_time: Date.now(), previous_page: fromState.url })
    }
  }

  function segmentPageChange (event, toState, toParams, fromState) {
    SegmentService.page(toState.name, toParams)
  }

  function thirdPartyPageChange (event, toState) {
    // Hotjar
    if (window.hj) {
      hj('stateChange', $location.url())
    }
  }

  function stageChange () {
    showAppLandingPage()

    var args = arguments
    pageChanges.forEach(function (f) {
      f.apply(null, args)
    })
  }

  function abortUpload (file) {
    if (typeof file.abortUpload === 'function') {
      file.abortUpload()
    }

    $rootScope.uploadingFiles.splice($rootScope.uploadingFiles.indexOf(file), 1)
  }

  function isMultilocalPlan () {
    return $rootScope.companyFeaturesAndAddons?.pricingPackageId !== 4
  }

  function isWorkflowPlan () {
    return $rootScope.companyFeaturesAndAddons?.pricingPackageId === 4
  }
}

export { initializerService }
